import { Dictionary } from 'src/utils';
import { container } from '../../../container';
import { DEPENDENCIES } from '../../../container/dependencies.const';
import { FacetsReconstructor } from '../../../services';
import { SEARCH_ACTIONS_KEYS, SEARCH_MUTATIONS_KEYS } from '../search.const';
import { SearchAction, SearchContext } from '../search.interfaces';

export class LoadPreselectedFiltersAction implements SearchAction {
  actions = {
    [SEARCH_ACTIONS_KEYS.loadPreselectedFilters]: ({ rootState, commit }: SearchContext): void => {
      const facetsReconstructor = container.get<FacetsReconstructor>(DEPENDENCIES.FacetsReconstructor);
      const preSelectedFilters = Object.entries(rootState.config.dynamic.filters ?? {}).reduce((parsedFacets, [facetName, filterValue]) => {
        parsedFacets[facetName] = [filterValue];
        return parsedFacets;
      }, {} as Dictionary<string[]>);
      const reconstructedFacets = facetsReconstructor.reconstruct(preSelectedFilters);
      commit(SEARCH_MUTATIONS_KEYS.setPreselectedFilters, reconstructedFacets);
    }
  };
}
